"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnDefinition = exports.getColumnsFromVNodes = exports.ItpDataTableColumn = void 0;
const cell_types_1 = require("./cell-types");
const lodash_1 = require("lodash");
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const helpers_1 = require("./helpers");
const constants_1 = require("./constants");
const cell_types_2 = require("./cell-types");
const validation_1 = require("./validation");
const eventargs_1 = require("./eventargs");
let ItpDataTableColumn = class ItpDataTableColumn extends vue_1.default {
};
exports.ItpDataTableColumn = ItpDataTableColumn;
exports.ItpDataTableColumn = ItpDataTableColumn = __decorate([
    (0, vue_property_decorator_1.Component)({})
], ItpDataTableColumn);
function getColumnsFromVNodes(nodes) {
    return (0, lodash_1.filter)(nodes, vnode => vnode.tag && vnode.tag.endsWith('ItpDataTableColumn')).map(col => {
        const attrs = (0, lodash_1.get)(col, 'data.attrs', {});
        return {
            ...attrs,
            attrs,
            scopedSlots: (0, lodash_1.get)(col, 'data.scopedSlots', {})
        };
    });
}
exports.getColumnsFromVNodes = getColumnsFromVNodes;
class ColumnDefinition {
    owner;
    name;
    field;
    type;
    header;
    headerIcon;
    headerTooltip;
    sortable;
    resizable;
    frozen;
    readonly;
    editable;
    disabled;
    template;
    default;
    cellClass;
    tabindex;
    minWidth;
    width;
    textAlign;
    headerTextAlign;
    size;
    validator;
    required;
    placeholder;
    sort;
    style;
    systemColumn;
    sticky;
    attrs;
    scopedSlots;
    colBindings;
    validationRules;
    renderer;
    cellFormatter;
    cellEditor;
    cellEditorIsDisabled;
    noFooterTotals;
    footerTotals;
    constructor(owner, config) {
        this.owner = owner;
        this.applyConfig(config);
    }
    applyConfig(config) {
        const cfg = { ...constants_1.DEFAULT_COLUMN_OPTIONS, ...config };
        this.name = cfg.name;
        this.disabled = config.disabled;
        this.default = config.default;
        this.field = cfg.field || this.name;
        this.type = cfg.type || 'text';
        this.systemColumn = cfg.systemColumn;
        this.renderer = { ...(0, cell_types_1.getColumnRenderer)(this.type) };
        if (cfg.formatter) {
            const formatterConfig = (0, lodash_1.isObject)(cfg.formatter)
                ? cfg.formatter
                : { ...config, name: cfg.formatter };
            this.cellFormatter = (0, cell_types_2.getFormatter)(formatterConfig);
        }
        else {
            this.cellFormatter = this.renderer.formatter.createComponent(this.renderer.formatter.schema.parse(cfg));
        }
        if (cfg.editor) {
            const editorConfig = (0, lodash_1.isObject)(cfg.editor)
                ? cfg.editor
                : { ...config, name: cfg.editor };
            this.cellEditor = (0, cell_types_2.getEditor)(editorConfig);
        }
        else if (this.renderer.editor) {
            this.cellEditor = this.renderer.editor.createComponent(this.renderer.editor.schema.parse(cfg));
        }
        this.cellEditorIsDisabled = cfg.editorIsDisabled;
        this.header = cfg.header || this.renderer.header || cfg.name;
        this.headerIcon = cfg.headerIcon || this.renderer.headerIcon;
        this.headerTooltip = (0, helpers_1.valueOrDefault)(cfg.headerTooltip, cfg.header);
        this.headerTextAlign = cfg.headerTextAlign;
        this.sortable = this.getSortable(cfg);
        this.sort = 0;
        this.resizable = cfg.systemColumn ? false : cfg.resizable;
        this.frozen = cfg.frozen;
        this.editable = (0, helpers_1.valueOrDefault)(cfg.editable, true);
        this.readonly = (0, helpers_1.valueOrDefault)(cfg.readonly, !this.editable);
        this.minWidth = (0, helpers_1.valueOrDefault)(cfg.minWidth, this.cellFormatter.minWidth);
        this.width = cfg.width;
        this.textAlign = cfg.textAlign;
        this.size = (0, helpers_1.valueOrDefault)(cfg.size, 'sm');
        this.cellClass = cfg.cellClass;
        this.tabindex = '0';
        this.required = (0, helpers_1.valueOrDefault)(cfg.required, false);
        this.placeholder = cfg.placeholder;
        this.style = {
            width: cfg.width || '60px'
        };
        this.sticky = cfg.sticky;
        this.attrs = cfg.attrs;
        this.colBindings = {
            'data-column': this.name,
            align: this.textAlign,
            valign: 'baseline'
        };
        this.scopedSlots = config.scopedSlots;
        this.validator = cfg.validator || [];
        this.validationRules = (0, validation_1.getValidationRules)((this.cellEditor && this.cellEditor.validators) || [], this.validator, {
            required: this.required
        });
        this.noFooterTotals = cfg.noFooterTotals;
        this.footerTotals = cfg.footerTotals;
    }
    mergeConfigIn(config) { }
    getCellClass(editing, row) {
        const textAlign = this.getEffectiveTextAlign(editing);
        const result = {
            'text-right': textAlign === 'right',
            'text-center': textAlign === 'center'
        };
        if ((0, lodash_1.isString)(this.cellClass)) {
            (0, lodash_1.each)(this.cellClass.trim().split(' '), p => (0, lodash_1.set)(result, p, true));
        }
        return (0, lodash_1.extend)(result, this.owner.model.getCellClass(this, row));
    }
    getCellHeaderClass() {
        let align = this.headerTextAlign;
        if (!align) {
            align = this.owner.model.defaultHeaderTextAlign;
        }
        return `text-${align || 'center'}`;
    }
    getHeaderClass() {
        let align = this.effectiveHeaderAlignment;
        align = `align-${align || 'left'}`;
        return [
            {
                'sticky-l': this.systemColumn && this.sticky === 'left',
                'sticky-r': this.systemColumn && this.sticky === 'right',
                sortable: this.isSortable
            },
            'font-size-smaller',
            align
        ];
    }
    get isSortable() {
        return this.owner.model.isSortable && this.sortable;
    }
    get effectiveHeaderAlignment() {
        return this.headerTextAlign || this.owner.model.defaultHeaderTextAlign;
    }
    get effectiveTabindex() {
        return this.owner.model.getColumnIndex(this).toString();
    }
    getEffectiveTextAlign(editing) {
        if (editing &&
            this.editable &&
            this.cellEditor &&
            this.cellEditor.textAlign) {
            return this.cellEditor.textAlign;
        }
        if (this.cellFormatter.textAlign) {
            return this.cellFormatter.textAlign;
        }
        if (this.textAlign) {
            return this.textAlign;
        }
        return this.owner.model.defaultTextAlign;
    }
    tabIndex;
    emit(event, ...args) {
        this.owner.callListeners(event, ...args);
    }
    emitCellEvent(event, row) {
        this.owner.callListeners(event, new eventargs_1.CellEventArgs(row, this, this.owner));
    }
    getSortable(config) {
        if (this.systemColumn) {
            return false;
        }
        if (this.renderer.sortable === false) {
            return false;
        }
        return (0, helpers_1.valueOrDefault)(config.sortable, true);
    }
}
exports.ColumnDefinition = ColumnDefinition;
//# sourceMappingURL=column.js.map